window.monthNamesFullen = ["January", "February", "March", "April", "May", "June","July", "August", "September", "October", "November", "December"];
window.monthNamesFullid = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];
window.monthNamesen = ["Jan", "Feb", "Mar", "Apr", "May", "Jun","Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
window.monthNamesid = ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agu", "Sep", "Okt", "Nov", "Des"];

window.weekdayen = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
window.weekdayid = ["Min","Sen","Sel","Rab","Kam","Jum","Sab"];
window.weekdayFullen = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
window.weekdayFullid = ["Minggu","Senin","Selasa","Rabu","Kamis","Jumat","Sabtu"];


window.DaysMinsSecsAgoDefiner = function(value, whichone)
{
    let ToReturnValue = value + " " + window[whichone + window.CurrentCountryID];
    if(value > 1)
    {
        ToReturnValue = value + " " + window[whichone + "ex" + window.CurrentCountryID];
    }
    //console.log(ToReturnValue);
    return ToReturnValue;
}

window.CurrentDisplayedDayEdit = null;
window.CurrentDisplayedMonthEdit = null;
window.CurrentDisplayedYearEdit = null;
window.CurrentSelectedDayEdit = null;
window.CurrentSelectedMonthEdit = null;
window.CurrentSelectedYearEdit = null;

window.WhichDateContainer = null;
window.WhichHowManyTextDisplayer = null;
window.OpposingContainer = null;
window.ThisStartEndType = null;
window.WhatDisplayFormat = null;
window.IsDateRemovable = null;
window.IsAllowSameDate = null;
window.DontAllowPastDate = null;

window.IsCalendarAnimating = false;

// =================================== DATE PICKER =======================================

window.OpenDateChoiceContainer = function(whichdatecontainerid, opposingcontainerid, togglearrowid, startendingtype, howmanynighttextid, whichdisplayformat, isremovable, allowsamedate, dontallowpastdate, instiateatleft, allowcheckinavailability,functiontocall)
{
    window.event.preventDefault();
    window.event.stopPropagation();

    window.RotateToggle(togglearrowid, true);
    window.IsCalendarAnimating = false;

    if(document.getElementById("WhitePanelContentContainer" + whichdatecontainerid) != null)
    {
        window.PanelChoiceOpen.remove();
        window.PanelChoiceOpen = null;
    }
    else
    {
        if(window.PanelChoiceOpen != null)
        {
            window.PanelChoiceOpen.remove();
            window.PanelChoiceOpen = null;
        }

        // ----------------------------- PREPARATION -----------------------------

        window.WhichDateContainer = document.getElementById(whichdatecontainerid);
        window.WhichHowManyTextDisplayer = null;
        if(howmanynighttextid != "")
        {
            window.WhichHowManyTextDisplayer = document.getElementById(howmanynighttextid);
        }

        window.CurrentDisplayedDayEdit = parseInt(window.WhichDateContainer.getAttribute("date"));
        window.CurrentDisplayedMonthEdit = parseInt(window.WhichDateContainer.getAttribute("month"));
        window.CurrentDisplayedYearEdit = parseInt(window.WhichDateContainer.getAttribute("year"));

        window.CurrentSelectedDayEdit = window.CurrentDisplayedDayEdit;
        window.CurrentSelectedMonthEdit = window.CurrentDisplayedMonthEdit;
        window.CurrentSelectedYearEdit = window.CurrentDisplayedYearEdit;

        window.OpposingContainer = "";
        if(opposingcontainerid != "")
        {
            window.OpposingContainer = document.getElementById(opposingcontainerid);
        }

        window.ThisStartEndType = startendingtype;
        window.WhatDisplayFormat = whichdisplayformat;
        window.IsDateRemovable = isremovable;
        window.IsAllowSameDate = allowsamedate;
        window.DontAllowPastDate = dontallowpastdate;

        // const thisdate = new Date(window.CurrentDisplayedYearEdit, window.CurrentDisplayedMonthEdit-1, window.CurrentDisplayedDayEdit);

        // ----------------------------- INSTANTIATE CALENDAR -----------------------------

        window.PanelChoiceOpen = document.createElement("div");
        window.PanelChoiceOpen.className = "ContainerFlex";
        window.PanelChoiceOpen.style.bottom = 0;
        window.WhichDateContainer.append(window.PanelChoiceOpen);

        let WhitePanelContentContainer = document.createElement("div");
        WhitePanelContentContainer.className = "WhitePanelContentContainer BasicRoundRadius";
        WhitePanelContentContainer.id = "WhitePanelContentContainer" + whichdatecontainerid;
        WhitePanelContentContainer.style.top = 0;
        if(instiateatleft == true)
        {
            WhitePanelContentContainer.style.left = 0;
        }
        else
        {
            WhitePanelContentContainer.style.right = 0;
        }
        WhitePanelContentContainer.onclick = function()
        {
            window.event.preventDefault();
            window.event.stopPropagation();
        }
        window.PanelChoiceOpen.append(WhitePanelContentContainer);
        // window.PanelChoiceOpen.style.top = window.WhichDateContainer.getBoundingClientRect().bottom + window.scrollY + 5;
        // window.PanelChoiceOpen.style.left = window.WhichDateContainer.getBoundingClientRect().left + window.scrollX - 0;
        // document.getElementsByTagName("body")[0].append(window.PanelChoiceOpen);

        let DatePickerHeader = document.createElement("div");
        DatePickerHeader.className = "DatePickerHeader";
        WhitePanelContentContainer.append(DatePickerHeader);

        let CurrentMonthandYear = document.createElement("p");
        CurrentMonthandYear.className = "CurrentMonthandYear InterBoldTextFont Selectable2";
        CurrentMonthandYear.id = "CurrentMonthandYearToEdit";
        CurrentMonthandYear.innerHTML = window["monthNamesFull" + window.CurrentCountryID][window.CurrentDisplayedMonthEdit - 1] + " " + window.CurrentDisplayedYearEdit;
        CurrentMonthandYear.onclick = function()
        {
            window.OpenMonthChoiceDropDown(allowcheckinavailability);
        }
        DatePickerHeader.append(CurrentMonthandYear);

        let MonthButtonContainer = document.createElement("div");
        MonthButtonContainer.className = "MonthButtonContainer";
        DatePickerHeader.append(MonthButtonContainer);

        let PreviousMonthButton = document.createElement("img");
        PreviousMonthButton.className = "PreviousMonthButton Selectable2";
        PreviousMonthButton.src = "/Assets/images/ButtonIcon/chevron.svg";
        PreviousMonthButton.id = "PreviousMonthButton";
        PreviousMonthButton.onclick = function()
        {
            window.NextDateOrPastChange(-1, PreviousMonthButton, CurrentMonthandYear, allowcheckinavailability, 100);
        }
        MonthButtonContainer.append(PreviousMonthButton);

        let NextMonthButton = document.createElement("img");
        NextMonthButton.className = "NextMonthButton Selectable2";
        NextMonthButton.src = "/Assets/images/ButtonIcon/chevron.svg";
        NextMonthButton.id = "NextMonthButton";
        NextMonthButton.onclick = function()
        {
            window.NextDateOrPastChange(1, PreviousMonthButton, CurrentMonthandYear, allowcheckinavailability, 100);
        }
        MonthButtonContainer.append(NextMonthButton);

        let DatePickerDateTable = document.createElement("div");
        DatePickerDateTable.className = "DatePickerDateTable";
        WhitePanelContentContainer.append(DatePickerDateTable);

        let CurrentMonthTable = document.createElement("table");
        CurrentMonthTable.className = "CurrentMonthTable";
        DatePickerDateTable.append(CurrentMonthTable);

        let TheadCalendarHeader = document.createElement("thead");
        TheadCalendarHeader.className = "TheadCalendarHeader InterBoldTextFont";
        CurrentMonthTable.append(TheadCalendarHeader);

        let TrCalendarHeader = document.createElement("tr");
        TrCalendarHeader.className = "TrCalendarHeader";
        TheadCalendarHeader.append(TrCalendarHeader);

        for(let i = 0; i < window["weekday" + window.CurrentCountryID].length; i++)
        {
            let HeaderDays = document.createElement("th");
            HeaderDays.className = "HeaderDays";
            if(i == 0 || i == 6)
            {
                HeaderDays.className = "HeaderDaysHoliday";
            }
            HeaderDays.innerHTML = window["weekday" + window.CurrentCountryID][i];
            TrCalendarHeader.append(HeaderDays);
        }

        var TBodyCalendar = document.createElement("tbody");
        TBodyCalendar.className = "TBodyCalendar InterRegularTextFont";
        TBodyCalendar.id = "TBodyCalendar";
        CurrentMonthTable.append(TBodyCalendar);


        let ApplyButtonContainer = document.createElement("div");
        ApplyButtonContainer.className = "ApplyButtonContainer";
        WhitePanelContentContainer.append(ApplyButtonContainer);
        
        let ApplyMonthButton = document.createElement("button");
        ApplyMonthButton.className = "ApplyMonthButton BasicRoundRadius Selectable";
        ApplyMonthButton.innerHTML = window["ApplyTxt" + window.CurrentCountryID];
        ApplyMonthButton.onclick = function()
        {
            window.ApplyDateChanges(whichdatecontainerid, opposingcontainerid, functiontocall);
        }
        ApplyButtonContainer.append(ApplyMonthButton);

        window.NextDateOrPastChange(0, PreviousMonthButton, CurrentMonthandYear, allowcheckinavailability, 0);
    }
}

window.InstantiateDatesInsideContainer = function(CurrentMonthandYear, durationtransition, allowcheckinavailability)
{
    let BodyCalendarToInstantiate = document.getElementById("TBodyCalendar");
    CurrentMonthandYear.innerHTML = window["monthNamesFull" + window.CurrentCountryID][window.CurrentDisplayedMonthEdit - 1] + " " + window.CurrentDisplayedYearEdit;

    if(window.IsCalendarAnimating == false)
    {
        window.IsCalendarAnimating = true;
        
        BodyCalendarToInstantiate.style.opacity = "0";
        BodyCalendarToInstantiate.animate([{opacity: '1'},{opacity: '0'}], {duration: durationtransition});

        setTimeout(function()
        {
            BodyCalendarToInstantiate.innerHTML = "";
    
            // Current Selected Date -------
            let CurrentSelectedFullDate = new Date(window.CurrentSelectedYearEdit, window.CurrentSelectedMonthEdit-1, window.CurrentSelectedDayEdit);
            //console.log(CurrentSelectedFullDate);
            
            // Get Today Date -------
            let WhatDayIsToday = window.GetAndConvertCurrentDate(false);
        
            // Get Today Date -------
            let OpposingDate = null;
            if(window.OpposingContainer != "")
            {
                let OpposingDay = window.OpposingContainer.getAttribute("date");
                let OpposingMonth = window.OpposingContainer.getAttribute("month");
                let OpposingYear = window.OpposingContainer.getAttribute("year");
        
                if(OpposingDay != null && OpposingMonth != null && OpposingYear != null)
                {
                    OpposingDate = new Date(parseInt(OpposingYear), parseInt(OpposingMonth)-1, parseInt(OpposingDay));
                }
            }
            
        
            // Instantiate Past Date ---------------------------------------
            
            let StartDateofCurrentDate = new Date(window.CurrentDisplayedYearEdit, window.CurrentDisplayedMonthEdit-1, 1);
            let WhichDayNumberStart = StartDateofCurrentDate.getDay();
        
            let TrCalendarBody = document.createElement("tr");
            TrCalendarBody.className = "TrCalendarBody";
            BodyCalendarToInstantiate.append(TrCalendarBody);
        
            for(let i = 0; i < WhichDayNumberStart; i++)
            {
                let DateButton = document.createElement("td");
                DateButton.className = "DateButton";
                TrCalendarBody.append(DateButton);
            }
        
            // Instantiate Current Date ---------------------------------------
        
            let i = 0;
            let HowManyDayThisMonth = new Date(window.CurrentDisplayedYearEdit, window.CurrentDisplayedMonthEdit, 0).getDate();
            let DateButtonsList = [];

            while (i < HowManyDayThisMonth)
            {
                let CurrentDisplayedDate = new Date(window.CurrentDisplayedYearEdit, window.CurrentDisplayedMonthEdit-1, i+1);
                let ThisDateDayNumber = CurrentDisplayedDate.getDay();
        
                if(ThisDateDayNumber == 0)
                {
                    TrCalendarBody = document.createElement("tr");
                    TrCalendarBody.className = "TrCalendarBody";
                    BodyCalendarToInstantiate.append(TrCalendarBody);
                }
        
                let DateButton = document.createElement("td");
                DateButton.className = "DateButton Selectable";
                DateButton.setAttribute("date", i+1);
                DateButton.setAttribute("month", window.CurrentDisplayedMonthEdit);
                DateButton.setAttribute("year", window.CurrentDisplayedYearEdit);
                DateButton.onclick = function()
                {
                    window.event.preventDefault();
                    window.event.stopPropagation();
        
                    window.CurrentSelectedDayEdit = parseInt(DateButton.getAttribute("date"));
                    window.CurrentSelectedMonthEdit = parseInt(DateButton.getAttribute("month"));
                    window.CurrentSelectedYearEdit = parseInt(DateButton.getAttribute("year"));
        
                    window.InstantiateDatesInsideContainer(CurrentMonthandYear, durationtransition, allowcheckinavailability);
                }
                TrCalendarBody.append(DateButton);
        
                if(CurrentSelectedFullDate.getTime() == CurrentDisplayedDate.getTime())
                {
                    DateButton.classList.add("CurrentSelectedDate");
                }
                else if(WhatDayIsToday.getTime() == CurrentDisplayedDate.getTime())
                {
                    DateButton.classList.add("ThisCurrentDate");
                }
        
                let DateButtonText = document.createElement("p");
                DateButtonText.innerHTML = (i+1);
                DateButton.append(DateButtonText);
        
                if(window.ThisStartEndType == "End" && OpposingDate != null)
                {
                    if(CurrentDisplayedDate.getTime() < OpposingDate.getTime() || (CurrentDisplayedDate.getTime() == OpposingDate.getTime() && window.IsAllowSameDate == false))
                    {
                        DateButton.classList.add("DateButtonInvalid");
                    }
                }
        
                if(window.DontAllowPastDate == true && CurrentDisplayedDate.getTime() < WhatDayIsToday.getTime())
                {
                    DateButton.classList.add("DateButtonInvalid");
                }

                if(allowcheckinavailability == true) // If Checking Availability True ----------------------------
                {
                    DateButton.style.opacity = "0";
                    DateButton.style.pointerEvents = "none";
                    DateButtonsList.push(DateButton);
                }

                i++;
            }

            // Checking Exist Room -----------------------------------------------
            if(allowcheckinavailability == true)
            {
                let ThisLoading = window.InstantiateLoadingCircle(BodyCalendarToInstantiate, true);
                window.CheckWhichDateExist(window.CurrentDisplayedMonthEdit, window.CurrentDisplayedYearEdit, DateButtonsList, ThisLoading);
            }

            BodyCalendarToInstantiate.animate([{opacity: '0'},{opacity: '1'}], {duration: durationtransition});
            setTimeout(function()
            {
                BodyCalendarToInstantiate.style.opacity = "1";
                window.IsCalendarAnimating = false;
            }, durationtransition);

        }, durationtransition);
    }
}

// ================================================ CHECK IF ROOM EXIST ================================================

window.CheckWhichDateExist = function (month, year, DateButtonsList, ThisLoading)
{
    let CheckRoomAvailabilityDate = "/v2/rooms/" + window.CurrentSelectedRoomID + "/monthly?month=" + month + "&year=" + year + "&rooms=" + window.RoomQuotaNonTop;

    window.CallApiAxios({
        method: "GET",
        url: CheckRoomAvailabilityDate,
    }).then(res =>
    {
        // console.log(CheckRoomAvailabilityDate);
        //console.log(res);

        let DateCheckData = res.data.data.dates;
        // console.log(DateCheckData);
        ThisLoading.remove();

        DateButtonsList.forEach(DateButton =>
        {
            let thisdateDay;
            let thisdateMonth;
            let thisdateYear;

            if(DateButton.getAttribute("What-date") != null && DateButton.getAttribute("What-date") != "")
            {
                let ThisDateButtonArray = DateButton.getAttribute("What-date").split("-");
                thisdateDay = ThisDateButtonArray[2];
                thisdateMonth = ThisDateButtonArray[1];
                thisdateYear = ThisDateButtonArray[0];
            }
            else
            {
                thisdateDay = DateButton.getAttribute("date");
                thisdateMonth = DateButton.getAttribute("month");
                thisdateYear = DateButton.getAttribute("year");
            }

            let thisdateFullDate = new Date(thisdateYear, parseInt(thisdateMonth)-1, thisdateDay);

            DateButton.style.opacity = "";
            DateButton.style.pointerEvents = "";

            for(let i = 0; i < DateCheckData.length; i++)
            {
                let ThisCheckDataSplit = DateCheckData[i].date.split("-");
                let ThisCheckDay = ThisCheckDataSplit[2];
                let ThisCheckMonth = ThisCheckDataSplit[1];
                let ThisCheckYear = ThisCheckDataSplit[0];
                let ThisCheckFullDate = new Date(parseInt(ThisCheckYear), parseInt(ThisCheckMonth)-1, parseInt(ThisCheckDay));

                if(ThisCheckFullDate.getTime() == thisdateFullDate.getTime() && DateCheckData[i].status_available == "No")
                {
                    DateButton.classList.add("ThisDateIsUnavailable");
                }
            }
        });
    })
    .catch(err =>
    {
        //console.log(err);
        DateButtonsList.forEach(DateButton =>
        {
            DateButton.style.opacity = "";
            DateButton.style.pointerEvents = "";
        });
        ThisLoading.remove();
    });
}


window.ApplyDateChanges = function(whichdatecontainerid, opposingcontainerid, functiontocall)
{
    window.event.preventDefault();
    window.event.stopPropagation();

    window.PanelChoiceOpen.remove();
    window.PanelChoiceOpen = null;

    let DateFinalDisplay = "";
    let DateFinalName = "";
    let OpposingDateFinalDisplay = "";
    let OpposingDateFinalName = "";


    let ThisNewFullDate = new Date(window.CurrentSelectedYearEdit, window.CurrentSelectedMonthEdit-1, window.CurrentSelectedDayEdit);
    DateFinalName = window["weekdayFull" + window.CurrentCountryID][ThisNewFullDate.getDay()];

    window.WhichDateContainer.setAttribute("date", window.CurrentSelectedDayEdit);
    window.WhichDateContainer.setAttribute("month", window.CurrentSelectedMonthEdit);
    window.WhichDateContainer.setAttribute("year", window.CurrentSelectedYearEdit);

    // TO DISPLAY ------------------------------------

    if(window.WhatDisplayFormat == 1)
    {
        DateFinalDisplay = window.CurrentSelectedDayEdit + " " + window["monthNames" + window.CurrentCountryID][window.CurrentSelectedMonthEdit-1] + " " + window.CurrentSelectedYearEdit;
    }
    else if(window.WhatDisplayFormat == 2)
    {
        DateFinalDisplay = window["monthNames" + window.CurrentCountryID][window.CurrentSelectedMonthEdit-1] + " " + window.CurrentSelectedDayEdit + ", " + window.CurrentSelectedYearEdit;
    }

    let DateTextDisplay = document.getElementById(whichdatecontainerid + "DateText");

    if(DateTextDisplay != null)
    {
       if(DateTextDisplay.tagName  == "INPUT")
       {
            DateTextDisplay.value = DateFinalDisplay;
       }
       else
       {
            DateTextDisplay.innerHTML = DateFinalDisplay;
       }
    }
    if(document.getElementById(whichdatecontainerid + "DayNameText") != null)
    {
        document.getElementById(whichdatecontainerid + "DayNameText").innerHTML = DateFinalName;
    }
    
    // Check If Start > End ------------------------------------

    if(window.ThisStartEndType == "Start")
    {
        let OpposingDate = parseInt(window.OpposingContainer.getAttribute("date"));
        let OpposingMonth = parseInt(window.OpposingContainer.getAttribute("month"));
        let OpposingYear = parseInt(window.OpposingContainer.getAttribute("year"));

        let OpposingFullDate = new Date(OpposingYear, OpposingMonth-1, OpposingDate);

        if((window.IsAllowSameDate == false && ThisNewFullDate.getTime() == OpposingFullDate.getTime()) || ThisNewFullDate.getTime() > OpposingFullDate.getTime())
        {
            OpposingFullDate = new Date(window.CurrentSelectedYearEdit, window.CurrentSelectedMonthEdit-1, window.CurrentSelectedDayEdit+1);
            OpposingDateFinalName = window["weekdayFull" + window.CurrentCountryID][OpposingFullDate.getDay()];

            OpposingDate = OpposingFullDate.getDate();
            OpposingMonth = OpposingFullDate.getMonth();
            OpposingYear = OpposingFullDate.getFullYear();

            if(window.WhatDisplayFormat == 1)
            {
                OpposingDateFinalDisplay = OpposingDate + " " + window["monthNames" + window.CurrentCountryID][OpposingMonth] + " " + OpposingYear;
            }
            else if(window.WhatDisplayFormat == 2)
            {
                OpposingDateFinalDisplay = window["monthNames" + window.CurrentCountryID][OpposingMonth] + " " + OpposingDate + ", " + OpposingYear;
            }

            if(window.OpposingContainer != "")
            {
                window.OpposingContainer.setAttribute("date", OpposingDate);
                window.OpposingContainer.setAttribute("month", OpposingMonth+1);
                window.OpposingContainer.setAttribute("year", OpposingYear);
            }

            if(document.getElementById(opposingcontainerid + "DateText") != null)
            {
                document.getElementById(opposingcontainerid + "DateText").innerHTML = OpposingDateFinalDisplay;
            }
            if(document.getElementById(opposingcontainerid + "DayNameText") != null)
            {
                document.getElementById(opposingcontainerid + "DayNameText").innerHTML = OpposingDateFinalName;
            }
        }
    }

    // Calculate Date Difference ----------------------------------------------

    if(window.WhichHowManyTextDisplayer != null)
    {
        let StartDateContainer = window.WhichDateContainer;
        let EndDateContainer = window.OpposingContainer;

        if(window.ThisStartEndType == "End")
        {
            StartDateContainer = window.OpposingContainer;
            EndDateContainer = window.WhichDateContainer;
        }

        let StartDateDay = parseInt(StartDateContainer.getAttribute("date"));
        let StartDateMonth = parseInt(StartDateContainer.getAttribute("month"));
        let StartDateYear = parseInt(StartDateContainer.getAttribute("year"));

        let EndDateDay = parseInt(EndDateContainer.getAttribute("date"));
        let EndDateMonth = parseInt(EndDateContainer.getAttribute("month"));
        let EndDateYear = parseInt(EndDateContainer.getAttribute("year"));

        let StartFullDate = new Date(StartDateYear, StartDateMonth-1, StartDateDay);
        let OpposingFullDate = new Date(EndDateYear, EndDateMonth-1, EndDateDay);

        let DifferenceBetweenDays = window.GetDateDifferences(OpposingFullDate, StartFullDate)
        window.WhichHowManyTextDisplayer.innerHTML = window.NightTextDisplayer(DifferenceBetweenDays)
    }

    // Call a Certain Function at the End ------------------------------------

    //console.log("functiontocall", functiontocall);

    if(functiontocall != null) // Call Function After It ----------------------
    {
        if(typeof functiontocall === 'string')
        {
            eval(functiontocall);
        }
        else
        {
            functiontocall();
        }
    }
}

window.NextDateOrPastChange = function(valueadd, PreviousMonthButton, CurrentMonthandYear, allowcheckinavailability, durationtransition)
{
    window.event.preventDefault();
    window.event.stopPropagation();

    if(window.IsCalendarAnimating == true)
        return

    // ============================= ADDING THE VALUE ====================================

    if(valueadd > 0  && window.CurrentDisplayedMonthEdit == 12)
    {
        window.CurrentDisplayedMonthEdit = 1;
    }
    else if(valueadd < 0 && window.CurrentDisplayedMonthEdit == 1)
    {
        window.CurrentDisplayedMonthEdit = 12;
    }
    else
    {
        window.CurrentDisplayedMonthEdit = window.CurrentDisplayedMonthEdit + valueadd;
    }

    window.InstantiateDatesInsideContainer(CurrentMonthandYear, durationtransition, allowcheckinavailability);

    // ============================ HIDE AND DISPLAY NEXT PREV BUTTON ===============================

    let CurrentDisplayedDate = new Date(window.CurrentDisplayedYearEdit, window.CurrentDisplayedMonthEdit-1, 1);

    let WhatDayIsToday = window.GetAndConvertCurrentDate(false);
    let TodayConvertedDate = new Date(WhatDayIsToday.getFullYear(), WhatDayIsToday.getMonth(), 1);

    PreviousMonthButton.style.display = "";

    if(window.DontAllowPastDate == true && CurrentDisplayedDate.getTime() <= TodayConvertedDate.getTime())
    {
        PreviousMonthButton.style.display = "none";
    }
    else if(window.ThisStartEndType == "End")
    {
        let OpposingDate = parseInt(window.OpposingContainer.getAttribute("date"));
        let OpposingMonth = parseInt(window.OpposingContainer.getAttribute("month"));
        let OpposingYear = parseInt(window.OpposingContainer.getAttribute("year"));
    
        let OpposingFullDateCheck1 = new Date(OpposingYear, OpposingMonth-1, 1);
        let OpposingFullDateCheckIfThisLast = new Date(OpposingYear, OpposingMonth-1, OpposingDate);

        let diffDays = window.GetDateDifferences(OpposingFullDateCheckIfThisLast, CurrentDisplayedDate)
        // let diffTime = Math.abs(OpposingFullDateCheckIfThisLast - CurrentDisplayedDate);
        // let diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)); 

        if(CurrentDisplayedDate.getTime() <= OpposingFullDateCheck1.getTime() || (window.IsAllowSameDate == false && diffDays == 1))
        {
            PreviousMonthButton.style.display = "none";
        }
    }
}

window.OpenMonthChoiceDropDown = function(allowcheckinavailability)
{
    let BasicBlackBlocker = document.createElement("div");
    BasicBlackBlocker.className = "BasicBlackBlocker";
    BasicBlackBlocker.onclick = function()
    {
        window.event.preventDefault();
        window.event.stopPropagation();
        window.RotateToggle("", true);

        if(window.DropDownInsideContainer != null)
        {
            window.DropDownInsideContainer.remove();
            window.DropDownInsideContainer = null;
        }
        else
        {
            BasicBlackBlocker.remove();
            //document.getElementsByTagName("body")[0].style.overflow = "auto";
        }
    }
    document.getElementsByTagName("body")[0].append(BasicBlackBlocker);

    let ChoicePanelContainer = document.createElement("div");
    ChoicePanelContainer.className = "FlexFullDisplayPanel";
    ChoicePanelContainer.style.overflow = "visible";
    ChoicePanelContainer.onclick = function()
    {
        window.event.preventDefault();
        window.event.stopPropagation();
        window.RotateToggle("", true);
        if(window.DropDownInsideContainer != null)
        {
            window.DropDownInsideContainer.remove();
            window.DropDownInsideContainer = null;
        }
    }
    BasicBlackBlocker.append(ChoicePanelContainer);

    let MonthHeaderText = document.createElement("p");
    MonthHeaderText.className = "SmallPanelHeaderText InterBoldTextFont";
    MonthHeaderText.innerHTML = window["MonthTxt" + window.CurrentCountryID] + ":";
    ChoicePanelContainer.append(MonthHeaderText);

    let MonthDropDownContainer = document.createElement("div");
    MonthDropDownContainer.className = "SmallPanelDropDownContainer";
    MonthDropDownContainer.setAttribute("current-month", window.CurrentDisplayedMonthEdit);
    ChoicePanelContainer.append(MonthDropDownContainer);

    let MonthDropDownInputWrapper = document.createElement("div");
    MonthDropDownInputWrapper.className = "SmallPanelDropDownInputWrapper Selectable3 InterMediumTextFont";
    MonthDropDownContainer.append(MonthDropDownInputWrapper);

    let MonthDropDownInputText = document.createElement("p");
    MonthDropDownInputText.className = "MonthInputChangeCurrentSelectedText";
    MonthDropDownInputText.innerHTML = window["monthNamesFull" + window.CurrentCountryID][window.CurrentDisplayedMonthEdit-1];
    MonthDropDownInputWrapper.append(MonthDropDownInputText);

    let MonthDropDownChevron = document.createElement("img");
    MonthDropDownChevron.className = "ChevronInsideInput ToggleArrow";
    MonthDropDownChevron.id = "MonthDropDownChevron";
    MonthDropDownChevron.style.rotate = "0deg";
    MonthDropDownChevron.src = "/Assets/images/ButtonIcon/chevron.svg";
    MonthDropDownInputWrapper.append(MonthDropDownChevron);


    let YearHeaderText = document.createElement("p");
    YearHeaderText.className = "SmallPanelHeaderText InterBoldTextFont";
    YearHeaderText.innerHTML = window["YearTxt" + window.CurrentCountryID] + ":";
    ChoicePanelContainer.append(YearHeaderText);

    let YearDropDownContainer = document.createElement("div");
    YearDropDownContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
    ChoicePanelContainer.append(YearDropDownContainer);

    let YearInput = document.createElement("input");
    YearInput.type = "number";
    YearInput.placeholder = "eg: 2024";
    YearInput.className = "InputFieldInsideSmallPanel InputFieldSelectable InterMediumTextFont";
    YearInput.value = window.CurrentDisplayedYearEdit;
    YearDropDownContainer.append(YearInput);


    MonthDropDownInputWrapper.onclick = function()
    {
        window.OpenDropDownMonth(MonthDropDownContainer, MonthDropDownInputText, YearInput.value);
    }

    YearInput.onfocus = function()
    {
        window.event.preventDefault();
        window.event.stopPropagation();
    }
    YearInput.addEventListener("focusout", (event) =>
    {
        let WhatDayIsToday = window.GetAndConvertCurrentDate(false);
        let ThisYear = WhatDayIsToday.getFullYear();
        let ThisMonth = WhatDayIsToday.getMonth();

        let CurrentInputMonth = parseInt(MonthDropDownContainer.getAttribute("current-month"));

        if(YearInput.value == null || YearInput.value == "")
        {
            YearInput.value = ThisYear;
        }
        else
        {
            
            if(YearInput.value <= ThisYear)
            {
                YearInput.value = ThisYear;
                if(CurrentInputMonth < (ThisMonth+1))
                {
                    MonthDropDownContainer.setAttribute("current-month", (ThisMonth+1));
                    MonthDropDownInputText.innerHTML = window["monthNamesFull" + window.CurrentCountryID][ThisMonth];
                }
            }
        }
    });


    // Button ----------

    let SmallPanelBottomButtonWrapper = document.createElement("div");
    SmallPanelBottomButtonWrapper.className = "SmallPanelBottomButtonWrapper";
    ChoicePanelContainer.append(SmallPanelBottomButtonWrapper);

    let CancelButton = document.createElement("button");
    CancelButton.className = "TextButtonSmallPanel InterBoldTextFont Selectable";
    CancelButton.onclick = function()
    {
        window.event.preventDefault();
        window.event.stopPropagation();
        window.RotateToggle("", true);

        BasicBlackBlocker.remove();
        // document.getElementsByTagName("body")[0].style.overflow = "auto";
    }
    CancelButton.innerHTML = window["CancelTxt" + window.CurrentCountryID];
    SmallPanelBottomButtonWrapper.append(CancelButton);

    let ApplyButton = document.createElement("button");
    ApplyButton.className = "BasicButtonSmallPanel InterMediumTextFont Selectable";
    ApplyButton.onclick = function()
    {
        window.event.preventDefault();
        window.event.stopPropagation();
        window.RotateToggle("", true);

        window.CurrentDisplayedMonthEdit = parseInt(MonthDropDownContainer.getAttribute("current-month"));
        window.CurrentDisplayedYearEdit = YearInput.value;
        window.NextDateOrPastChange(0, document.getElementById("PreviousMonthButton"), document.getElementById("CurrentMonthandYearToEdit"), allowcheckinavailability, 100);
        
        BasicBlackBlocker.remove();
        //document.getElementsByTagName("body")[0].style.overflow = "auto";
    }
    ApplyButton.innerHTML = window["ApplyTxt" + window.CurrentCountryID];
    SmallPanelBottomButtonWrapper.append(ApplyButton);

    //document.getElementsByTagName("body")[0].style.overflow = "hidden";
}

window.OpenDropDownMonth = function(MonthDropDownContainer, MonthDropDownInputText, YearInputValue)
{
    window.event.preventDefault();
    window.event.stopPropagation();
    window.RotateToggle("MonthDropDownChevron", true);

    if(window.DropDownInsideContainer != null)
    {
        window.DropDownInsideContainer.remove();
        window.DropDownInsideContainer = null;
    }
    else
    {
        let WhatDayIsToday = window.GetAndConvertCurrentDate(false);
        let WhatMonth = WhatDayIsToday.getMonth();
        let WhatYear = WhatDayIsToday.getFullYear();
        //console.log(WhatDayIsToday);
    
        window.DropDownInsideContainer = document.createElement("div");
        window.DropDownInsideContainer.className = "ContainerFlex";
        window.DropDownInsideContainer.style.bottom = 0;
        MonthDropDownContainer.append(window.DropDownInsideContainer);
    
        let DropDownContainer = document.createElement("div");
        DropDownContainer.className = "DropDownContainer HideScrollBar";
        window.DropDownInsideContainer.append(DropDownContainer);
    
    
        let CurrentSelected = parseInt(MonthDropDownContainer.getAttribute("current-month"));
        let ScrollToDropDown;
    
        for(let i = 0; i < window["monthNamesFull" + window.CurrentCountryID].length; i++)
        {
            let DropDownSelectionContainer = document.createElement("button");
            DropDownSelectionContainer.className = "DropDownSelectionContainer";
    
            if(i < WhatMonth && YearInputValue == WhatYear)
            {
                DropDownSelectionContainer.classList.add("DropDownInvalid");
                DropDownSelectionContainer.onclick = function()
                {
                    window.event.preventDefault();
                    window.event.stopPropagation();
                }
            }
            else 
            {
                if(CurrentSelected == (i+1))
                {
                    DropDownSelectionContainer.classList.add("DropDownSelectionContainerSelected");
                    ScrollToDropDown = DropDownSelectionContainer;
                }

                DropDownSelectionContainer.onclick = function()
                {
                    MonthDropDownContainer.setAttribute("current-month", i+1);
                    MonthDropDownInputText.innerHTML = window["monthNamesFull" + window.CurrentCountryID][i];
                }
            }
            DropDownContainer.append(DropDownSelectionContainer);
        
            let DropDownSelectionText = document.createElement("p");
            DropDownSelectionText.className = "DropDownSelectionText";
            DropDownSelectionText.innerHTML = window["monthNamesFull" + window.CurrentCountryID][i];
            DropDownSelectionContainer.append(DropDownSelectionText);
        }

        window.ScrollToSelectedDropDown(DropDownContainer, ScrollToDropDown)
    }
}

// ============================================== TIMER RELATED FUNCTIONS =========================================

window.EndTimeCountDown = null;
window.wasHidden = false;
window.CountDownTimerInterval = null;
window.VisibilityChangeHandler = null;

window.StartCountDown = function(whichtext, whichtype, functioncallafterreload, functioncallafterend) // Start Countdown
{
    window.RemoveTimerAndVisibility(true);

    // Add Function On Visibility Change -------------------------------------
    window.AddOnVisibilityChangeFunction(functioncallafterreload);

    // Start Timer -------------------------------------
    window.updateTimer(whichtext, whichtype, functioncallafterend);

    window.CountDownTimerInterval = setInterval(() =>
    {
        window.updateTimer(whichtext, whichtype, functioncallafterend);
    }, 1000);
}


window.updateTimer = function(whichtext, whichtype, functioncallafterend) // Update Countdown
{
    let now = window.ConvertThisToDate(null, true);
    let currenttime = Math.max(0, Math.floor((window.EndTimeCountDown - now) / 1000));

    let Hours = Math.floor(currenttime / 3600);
    let Minute = Math.floor((currenttime - (Hours * 3600)) / 60);
    let Second = currenttime - (Hours * 3600) - (Minute * 60);
    let MessageTextToDisplay = "";

    if(whichtype = 1)
    {
        let HoursMessage =  Hours.toString().padStart(2, '0') +  " " + window["HourTxt" + window.CurrentCountryID].toLowerCase() + " : ";
        if(Hours > 1)
        {
            HoursMessage =  Hours.toString().padStart(2, '0') +  " " + window["HourTxtex" + window.CurrentCountryID].toLowerCase() + " : ";
        }

        let MinutesMessage =  Minute.toString().padStart(2, '0') +  " " + window["MinTxt" + window.CurrentCountryID].toLowerCase() + " : ";
        if(Minute > 1)
        {
            MinutesMessage =  Minute.toString().padStart(2, '0') +  " " + window["MinTxtex" + window.CurrentCountryID].toLowerCase() + " : ";
        }

        let SecondMessage =  Second.toString().padStart(2, '0') +  " " + window["SecTxt" + window.CurrentCountryID].toLowerCase();
        if(Second > 1)
        {
            SecondMessage =  Second.toString().padStart(2, '0') +  " " + window["SecTxtex" + window.CurrentCountryID].toLowerCase();
        }

        MessageTextToDisplay = HoursMessage + MinutesMessage + SecondMessage;
    }
    
    if(Array.isArray(whichtext))
    {
        whichtext.forEach(element =>
        {
            element.innerHTML = MessageTextToDisplay;
        });
    }
    else
    {
        whichtext.innerHTML = MessageTextToDisplay;
    }

    if(currenttime <= 0)
    {
        window.RemoveTimerAndVisibility(false);

        if (typeof functioncallafterend === 'function')
        {
            functioncallafterend();
        }
    }
}

window.RemoveTimerAndVisibility = function(isremoveeventlistener) // Remove Timer + Visibility
{
    if(window.CountDownTimerInterval === null || isremoveeventlistener == false) // Clear Countdown
    {
        clearInterval(window.CountDownTimerInterval);
    }

    if(isremoveeventlistener == true) // Remove Visibility Change Function
    {
        document.removeEventListener("visibilitychange", window.VisibilityChangeHandler);
    }
}

// =========================== OTHER DATE TIME RELATED ===========================

window.ConvertThisToDate = function(thisdatedata, isthisalreadyutc) // Get Today Date or Convert Date and Time String Into DATE Value 
{
    let DateToReturn;

    if(thisdatedata == null)
    {
        const now = new Date();
        const utc = now.getTime() + now.getTimezoneOffset() * 60000;
        const jakartaOffset = 7 * 60 * 60000; // UTC+7
        DateToReturn = new Date(utc + jakartaOffset);
    }
    else
    {
        thisdatedata = (thisdatedata || "").trim();
        
        if (/^\d{4}-\d{2}-\d{2}T/.test(thisdatedata))
        {
            let d = new Date(thisdatedata);
            if (!isNaN(d)) return d;
        }

        let DateArray = [];
        let TimeArray = [];

        if(thisdatedata === "")
        {
            const now = new Date();
            const utc = now.getTime() + now.getTimezoneOffset() * 60000;
            const jakartaOffset = 7 * 60 * 60000;
            return new Date(utc + jakartaOffset);
        }

        if(thisdatedata.includes(" ") && thisdatedata.includes("-") && thisdatedata.includes(":"))
        {
            let TimeDateArray = thisdatedata.split(" ");
            DateArray = TimeDateArray[0].split("-");
            TimeArray = TimeDateArray[1].split(":");
        }
        else
        {
            DateArray = thisdatedata.split("-");
            TimeArray = [0, 0, 0];
        }

        if(isthisalreadyutc == true)
        {
            return new Date(DateArray[0], DateArray[1]-1, DateArray[2], TimeArray[0], TimeArray[1], TimeArray[2]);
        }
        else
        {
            return new Date(Date.UTC(DateArray[0], DateArray[1]-1, DateArray[2], TimeArray[0], TimeArray[1], TimeArray[2]));
        }
    }

    return DateToReturn;
}

window.formatDateTime = function(date) // Convert This Date Value To Sting ---------------------------------------
{
    const pad = (n) => n.toString().padStart(2, '0');

    return date.getFullYear() + '-' +
        pad(date.getMonth() + 1) + '-' +
        pad(date.getDate()) + ' ' +
        pad(date.getHours()) + ':' +
        pad(date.getMinutes()) + ':' +
        pad(date.getSeconds());
}

window.GetAndConvertCurrentDate = function(returninconverted) // This one Exclusively convert Time to 00:00:00 ----------------------
{
    let TodayDate = new Date();
    let ConvertedDate = window.ConvertDateTimeZone(TodayDate);
    const SplittedDateArray = ConvertedDate.split("/");
    let ThisFullTime = window.ConvertHourTimeZone(TodayDate).split(":");
    let ThisHour = parseInt(ThisFullTime[0]);
    if(ThisHour == 24)
    {
        ThisHour = 0;
    }
    let ThisMinutes = parseInt(ThisFullTime[1]);
    let ThisSecond = parseInt(ThisFullTime[2]);

    let NewFullDate = SplittedDateArray[2] + "-" + SplittedDateArray[0].toString().padStart(2, '0') + "-" + SplittedDateArray[1].toString().padStart(2, '0') + " " + ThisHour + ":" + ThisMinutes + ":" + ThisSecond;
    if(returninconverted == false)
    {
        NewFullDate = new Date(SplittedDateArray[2], parseInt(SplittedDateArray[0])-1, SplittedDateArray[1]);
    }
    return NewFullDate;
}

window.GetAndConvertCurrentExactDate = function(returninconverted) // This one Exclusively Don't Convert Time ----------------------
{
    const now = new Date();

    // Convert to Jakarta time
    const jakarta = new Date(
        now.toLocaleString("en-US", { timeZone: "Asia/Jakarta" })
    );

    if (returninconverted)
    {
        return window.formatDateTime(jakarta);
    }

    return jakarta;
}

// function WhichDayArrayJakarta()
// {
//     // Get current date and time in Asia/Jakarta timezone
//     let jakartaDate = new Date().toLocaleString('en-US', { timeZone: 'Asia/Jakarta' });

//     // Convert to Date object
//     let dateInJakarta = new Date(jakartaDate);

//     // Get the day of the week as a number (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
//     let dayOfWeek = dateInJakarta.getUTCDay();

//     // Adjust the day number so that 1 = Monday and 7 = Sunday
//     let dayNumber = (dayOfWeek === 0) ? 6 : dayOfWeek - 1;
//     return dayNumber;
// }

window.ConvertDateTimeZone = function(thishour)
{
    let options = {
        timeZone: 'Asia/Jakarta',
        year: "numeric",
        month: "numeric",
        day: "numeric",
    },
    formatter = new Intl.DateTimeFormat('en-US', options);

    return formatter.format(thishour);
}

window.ConvertHourTimeZone = function(thishour)
{
    let options = {
        timeZone: 'Asia/Jakarta',
        hourCycle: "h24",
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
    },
    formatter = new Intl.DateTimeFormat('en-US', options);

    return formatter.format(thishour);
}



// function ConvertDatesAndTimeFromDatabase(thistime)
// {
//     let DateTimeArray = thistime.split(" ");
//     let FullDate = new Date(DateTimeArray[0]);

//     let FullTimeArray = DateTimeArray[1].split(":");
//     ResultDate = FullDate.setHours(FullTimeArray[0], FullTimeArray[1], FullTimeArray[2]);

//     //console.log("Converting Date...");
//     //console.log(thistime);
//     //console.log(ResultDate);
//     return FullDate;
// }

// function CalculateTimeDifferences(firstdate, seconddate)
// {
//     let t1 = firstdate;
//     let t2 = seconddate;
//     let dif = (t2.getTime() - t1.getTime()) / 1000;
//     return dif;
// }

// function GetHowManyDayIsThisMonth(month, year)
// {
//     return new Date(year, month, 0).getDate();
// }

window.ConvertTimeIntoAMPMValue = function(thistime) // Convert Time String Into Time Array With AM PM
{
    let [hour, minute, second] = thistime.split(":").map(Number);

    let ampm = hour >= 12 ? "PM" : "AM";

    hour = hour % 12;
    hour = hour === 0 ? 12 : hour;

    let ArrayToReturn = 
    {
        "hour":hour,
        "minute":minute,
        "ampm":ampm,
    }

    return ArrayToReturn;
}

window.to24HourFormat = function(hour, minutes, ampm) // Convert Date Into 24 Hour Format
{
    hour = parseInt(hour, 10);
    minutes = parseInt(minutes, 10);

    if(ampm.toUpperCase() === "PM" && hour !== 12)
    {
        hour += 12;
    }
    if(ampm.toUpperCase() === "AM" && hour === 12)
    {
        hour = 0;
    }

    // Pad with leading zeros
    let hourStr = hour.toString().padStart(2, '0');
    let minuteStr = minutes.toString().padStart(2, '0');

    return `${hourStr}:${minuteStr}:00`;
}


// ============================== FUNCTION GET TWO DATE/ TIME DIFF =====================================

window.GetDateDifferences = function(whichdatestart, whichdatereducer) // -- Nights
{
    let CheckInDateFormat = whichdatestart;
    let CheckOutDateFormat = whichdatereducer;
    
    if(whichdatestart instanceof Date == false && whichdatereducer instanceof Date == false)
    {
        let CheckInArray = whichdatestart.split("-");
        CheckInDateFormat = new Date(CheckInArray[0], parseInt(CheckInArray[1] - 1), CheckInArray[2]);
        let CheckOutArray = whichdatereducer.split("-");
        CheckOutDateFormat = new Date(CheckOutArray[0], parseInt(CheckOutArray[1] - 1), CheckOutArray[2]);
    }
    let diffTime = Math.abs(CheckInDateFormat - CheckOutDateFormat);
    let diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)); 
    return diffDays
}

window.GetHowManyPastMinHourDaysDate = function(thisdateandtime) // -- Sec, -- Min, -- Hour, etc
{
    //------------------------------- GET THE FULL DATE --------------------------------------
    
    // var PastTime = "2024-01-04 14:08:11";
    // let PastDateTimeArray = thisdateandtime.split(" ");
    
    // let PastDateArray = PastDateTimeArray[0].split("-");
    // let PastYear = PastDateArray[0];
    // let PastMonth = (parseInt(PastDateArray[1])-1);
    // let PastDay = PastDateArray[2];

    // let PastTimeArray = PastDateTimeArray[1].split(":");
    // let PastHour = PastTimeArray[0];
    // let PastMinutes = PastTimeArray[1];
    // let PastSecond = PastTimeArray[2];

    // let PastFullDateTime = new Date(PastYear, PastMonth, PastDay, PastHour, PastMinutes, PastSecond);

    let PastFullDateTime = window.ConvertThisToDate(thisdateandtime, true);

    //---------------------------------------------------------------------------------------

    let seconds = Math.floor((new Date() - PastFullDateTime) / 1000);

    // Years Ago ---------------
    let interval = seconds / 31536000;
    if (interval > 1)
    {
        return window["monthNames" + window.CurrentCountryID][PastFullDateTime.getMonth()] + " " + PastFullDateTime.getDate() + ", " + PastFullDateTime.getFullYear();
    //   return Math.floor(interval) + " Years Ago";
    }

    // Months Ago ---------------
    interval = seconds / 2592000;
    if (interval > 1)
    {
        return window["monthNames" + window.CurrentCountryID][PastFullDateTime.getMonth()] + " " + PastFullDateTime.getDate() + ", " + PastFullDateTime.getFullYear();
    //   return Math.floor(interval) + " Months Ago";
    }

    // Days Ago ---------------
    interval = seconds / 86400;
    if(interval > 1)
    {
        return window.DaysMinsSecsAgoDefiner(Math.floor(interval), "DayAgoTxt")
    }

    // Hours Ago ---------------
    interval = seconds / 3600;
    if(interval > 1)
    {
        return window.DaysMinsSecsAgoDefiner(Math.floor(interval), "HourAgoTxt")
    }

    // Minutes Ago ---------------
    interval = seconds / 60;
    if(interval > 1)
    {
        return window.DaysMinsSecsAgoDefiner(Math.floor(interval), "MinAgoTxt")
    }

    // Seconds Ago ---------------
    return window.DaysMinsSecsAgoDefiner(Math.floor(seconds), "SecAgoTxt")
}


window.getCalendarMonthDiff = function(startDate, endDate)
{
  return ((endDate.getFullYear() - startDate.getFullYear()) * 12 + (endDate.getMonth() - startDate.getMonth()));
}


// =============================== SCROLL TIME MENU ===============================

window.InstantiateTimeScrollDownMenu = function(whichtimecontainerid, whichtimetextid, togglearrowid, instiateatleft, functiontocall)
{
    window.event.preventDefault();
    window.event.stopPropagation();

    window.RotateToggle(togglearrowid, true);

    let WhichVerifyTimeContainer = document.getElementById(whichtimecontainerid);
    let WhichVerifyText = document.getElementById(whichtimetextid);

    if(document.getElementById("TimeScrollDownContainer" + whichtimecontainerid) != null)
    {
        window.PanelChoiceOpen.remove();
        window.PanelChoiceOpen = null;
    }
    else
    {
        if(window.PanelChoiceOpen != null)
        {
            window.PanelChoiceOpen.remove();
            window.PanelChoiceOpen = null;
        }

        let CurrentHour = WhichVerifyTimeContainer.getAttribute("hour-value");
        let CurrentMinutes = WhichVerifyTimeContainer.getAttribute("min-value");
        let CurrentAMPM = WhichVerifyTimeContainer.getAttribute("ampm-value");

        window.PanelChoiceOpen = document.createElement("div");
        window.PanelChoiceOpen.className = "ContainerFlex";
        window.PanelChoiceOpen.style.bottom = 0;
        WhichVerifyTimeContainer.append(window.PanelChoiceOpen);

        let whitePanelContainer = document.createElement("div");
        whitePanelContainer.className = "WhitePanelContentContainer BasicRoundRadius";
        whitePanelContainer.id = "TimeScrollDownContainer" + whichtimecontainerid;
        whitePanelContainer.onclick = function()
        {
            window.event.preventDefault();
            window.event.stopPropagation();
        }
        whitePanelContainer.style.top = 0;
        if(instiateatleft == true)
        {
            whitePanelContainer.style.left = 0;
        }
        else
        {
            whitePanelContainer.style.right = 0;
        }
        window.PanelChoiceOpen.append(whitePanelContainer);

        // ============================== Header Section ==============================

        let TimePickerHeader = document.createElement("div");
        TimePickerHeader.className = "DatePickerHeader";
        whitePanelContainer.append(TimePickerHeader);

        let CurrentTimeText = document.createElement("p");
        CurrentTimeText.className = "CurrentMonthandYear InterBoldTextFont";
        CurrentTimeText.textContent = "2:47 PM";
        TimePickerHeader.append(CurrentTimeText);

        let CurrentTimeCancelContainer = document.createElement("div");
        CurrentTimeCancelContainer.className = "MonthButtonContainer";
        TimePickerHeader.append(CurrentTimeCancelContainer);

        let closeButton = document.createElement("img");
        closeButton.className = "CloseButtonInsidePanel Selectable2";
        closeButton.src = "/Assets/images/ButtonIcon/cancel-x-grey.svg";
        CurrentTimeCancelContainer.append(closeButton);

        // ===== Date Picker Table =====

        let TimeScrollContainerMain = document.createElement("div");
        TimeScrollContainerMain.className = "DatePickerDateTable";
        whitePanelContainer.append(TimeScrollContainerMain);

        let TimeScrollWrapper = document.createElement("div");
        TimeScrollWrapper.className = "PaymentTransferTimeSelectionContainer";
        TimeScrollContainerMain.append(TimeScrollWrapper);

        // === Hour Column ===
        let HourSectionMainContainer = document.createElement("div");
        HourSectionMainContainer.style.cssText = "width: fit-content; height: fit-content; position: relative; display: flex; flex-direction: column;";
        TimeScrollWrapper.append(HourSectionMainContainer);

        let HourSectionHeaderContainer = document.createElement("div");
        HourSectionHeaderContainer.className = "PaymentTransferTypeHeaderContainer";
        HourSectionMainContainer.append(HourSectionHeaderContainer);

        let HourSectionHeaderText = document.createElement("p");
        HourSectionHeaderText.className = "PaymentTransferTypeHeaderText InterBoldTextFont";
        HourSectionHeaderText.textContent = "Hour";
        HourSectionHeaderContainer.append(HourSectionHeaderText);

        let HourSectionScrollContainer = document.createElement("div");
        HourSectionScrollContainer.style.cssText = "width: fit-content; height: fit-content; position: relative;";
        HourSectionMainContainer.append(HourSectionScrollContainer);

        let HourSectionScrollWrapper = document.createElement("div");
        HourSectionScrollWrapper.className = "PaymentTransferTimeHourMinutesScrolParent";
        HourSectionScrollContainer.append(HourSectionScrollWrapper);

        let HourSectionScrollSwiperContainer = document.createElement("div");
        HourSectionScrollSwiperContainer.className = "PaymentTransferTimeHourMinutesScrolWrapper";
        HourSectionScrollWrapper.append(HourSectionScrollSwiperContainer);

        let HourSectionScrollSwiperWrapper = document.createElement("div");
        HourSectionScrollSwiperWrapper.className = "swiper-wrapper";
        HourSectionScrollSwiperContainer.append(HourSectionScrollSwiperWrapper);

         for(let i = 1; i < 13; i++)
         {
            let HourSwiperSlide = document.createElement("div");
            HourSwiperSlide.className = "swiper-slide PaymentTimeScrollable";
            HourSwiperSlide.setAttribute("hour-value", i);
            HourSectionScrollSwiperWrapper.append(HourSwiperSlide);

            let HourSwiperSlideText = document.createElement("p");
            HourSwiperSlideText.className = "PaymentTimeText InterBoldTextFont";
            HourSwiperSlideText.textContent = i;
            HourSwiperSlide.append(HourSwiperSlideText);
         }

        let selectedHourBorder = document.createElement("div");
        selectedHourBorder.className = "SelectedTimeBorder";
        selectedHourBorder.innerHTML = `<div class="SelectedTimeUpSide"></div><div class="SelectedTimeDownSide"></div>`;
        HourSectionScrollContainer.append(selectedHourBorder);

        // === Divider Column ===
        let dividerCol = document.createElement("div");
        dividerCol.style.cssText = "width: fit-content; height: fit-content; position: relative; display: flex; flex-direction: column;";
        TimeScrollWrapper.append(dividerCol);

        let dividerHeaderContainer = document.createElement("div");
        dividerHeaderContainer.className = "PaymentTransferTypeHeaderContainer";
        dividerCol.append(dividerHeaderContainer);

        let dividerHeaderText = document.createElement("p");
        dividerHeaderText.className = "PaymentTransferTypeHeaderText InterMediumTextFont";
        dividerHeaderText.style.opacity = "0";
        dividerHeaderText.textContent = ":";
        dividerHeaderContainer.append(dividerHeaderText);

        let dividerWrapperParent = document.createElement("div");
        dividerWrapperParent.style.cssText = "width: fit-content; height: fit-content; position: relative;";
        dividerCol.append(dividerWrapperParent);

        let dividerWrapper = document.createElement("div");
        dividerWrapper.className = "PaymentHourAndMinutesDividerWrapper";
        dividerWrapperParent.append(dividerWrapper);

        let dividerP = document.createElement("p");
        dividerP.className = "PaymentTimeText InterRegularTextFont";
        dividerP.style.margin = "auto";
        dividerP.textContent = ":";
        dividerWrapper.append(dividerP);

        let dividerBorder = document.createElement("div");
        dividerBorder.className = "SelectedTimeBorder";
        dividerBorder.innerHTML = `<div class="SelectedTimeUpSide"></div><div class="SelectedTimeDownSide"></div>`;
        dividerWrapperParent.append(dividerBorder);

        // === Minutes Column ===
        let minCol = document.createElement("div");
        minCol.style.cssText = "width: fit-content; height: fit-content; position: relative; display: flex; flex-direction: column;";
        TimeScrollWrapper.append(minCol);

        let minHeaderContainer = document.createElement("div");
        minHeaderContainer.className = "PaymentTransferTypeHeaderContainer";
        minCol.append(minHeaderContainer);

        let minHeaderText = document.createElement("p");
        minHeaderText.className = "PaymentTransferTypeHeaderText InterMediumTextFont";
        minHeaderText.textContent = "Min";
        minHeaderContainer.append(minHeaderText);

        let minWrapperParent = document.createElement("div");
        minWrapperParent.style.cssText = "width: fit-content; height: fit-content; position: relative;";
        minCol.append(minWrapperParent);

        let minScrollParent = document.createElement("div");
        minScrollParent.className = "PaymentTransferTimeHourMinutesScrolParent";
        minWrapperParent.append(minScrollParent);

        let minScrollWrapper = document.createElement("div");
        minScrollWrapper.className = "PaymentTransferTimeHourMinutesScrolWrapper";
        minScrollParent.append(minScrollWrapper);

        let minSwiperWrapper = document.createElement("div");
        minSwiperWrapper.className = "swiper-wrapper";
        minScrollWrapper.append(minSwiperWrapper);

        for(let i = 0; i < 60; i++)
        {
            let minSlide = document.createElement("div");
            minSlide.className = "swiper-slide PaymentTimeScrollable";
            minSlide.setAttribute("min-value", i);
            minSwiperWrapper.append(minSlide);

            let minP = document.createElement("p");
            minP.className = "PaymentTimeText InterMediumTextFont";
            minP.textContent = i.toString().padStart(2, '0');
            minSlide.append(minP);
        }

        let minBorder = document.createElement("div");
        minBorder.className = "SelectedTimeBorder";
        minBorder.innerHTML = `<div class="SelectedTimeUpSide"></div><div class="SelectedTimeDownSide"></div>`;
        minWrapperParent.append(minBorder);

        // === AM/PM Column ===
        let ampmCol = document.createElement("div");
        ampmCol.style.cssText = "width: fit-content; height: fit-content; position: relative; display: flex; flex-direction: column;";
        TimeScrollWrapper.append(ampmCol);

        let ampmHeaderContainer = document.createElement("div");
        ampmHeaderContainer.className = "PaymentTransferTypeHeaderContainer";
        ampmCol.append(ampmHeaderContainer);

        let ampmHeaderText = document.createElement("p");
        ampmHeaderText.className = "PaymentTransferTypeHeaderText InterMediumTextFont";
        ampmHeaderText.textContent = "AM/PM";
        ampmHeaderContainer.append(ampmHeaderText);

        let ampmWrapperParent = document.createElement("div");
        ampmWrapperParent.style.cssText = "width: fit-content; height: fit-content; position: relative;";
        ampmCol.append(ampmWrapperParent);

        let ampmScrollParent = document.createElement("div");
        ampmScrollParent.className = "PaymentTransferTimeHourMinutesScrolParent";
        ampmScrollParent.style.display = "flex";
        ampmWrapperParent.append(ampmScrollParent);

        let ampmScroll = document.createElement("div");
        ampmScroll.className = "TransferTimeAMPMScroll";
        ampmScrollParent.append(ampmScroll);

        let ampmSwiperWrapper = document.createElement("div");
        ampmSwiperWrapper.className = "swiper-wrapper";
        ampmScroll.append(ampmSwiperWrapper);

        let CurrentAMPMIndex = 0;
        let AMPMList = ["AM","PM"];
        for(let i = 0; i < AMPMList.length; i++)
        {
            let ampmSlide = document.createElement("div");
            ampmSlide.className = "swiper-slide PaymentTimeScrollable";
            ampmSlide.setAttribute("ampm-value", AMPMList[i]);
            ampmSwiperWrapper.append(ampmSlide);

            let ampmP = document.createElement("p");
            ampmP.className = "PaymentTimeText InterRegularTextFont";
            ampmP.textContent = AMPMList[i];
            ampmSlide.append(ampmP);

            if(AMPMList[i] == CurrentAMPM)
            {
                CurrentAMPMIndex = i;
            }
        }

        let ampmBorder = document.createElement("div");
        ampmBorder.className = "SelectedTimeBorder";
        ampmBorder.innerHTML = `<div class="SelectedTimeUpSide"></div><div class="SelectedTimeDownSide"></div>`;
        ampmWrapperParent.append(ampmBorder);

        // ===== Apply Button =====
        let applyButtonContainer = document.createElement("div");
        applyButtonContainer.className = "ApplyButtonContainer";
        whitePanelContainer.append(applyButtonContainer);

        let pingNowButton = document.createElement("button");
        pingNowButton.className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop Selectable";
        pingNowButton.style.margin = "0 auto";
        pingNowButton.style.width = "85%";
        pingNowButton.textContent = "Ping Now";
        applyButtonContainer.append(pingNowButton);


        // SET SWIPER ==========================

        let SwiperHours = new window.Swiper(HourSectionScrollSwiperContainer,
        {
            direction: 'vertical',
            slidesPerView: 5,
            spaceBetween: 5,
            mousewheel: true,
            loop: true,
            observer: true,
            observeParents: true,
        });
        SwiperHours.slideTo(parseInt(CurrentHour) + 2);
    
        let SwiperMinutes = new window.Swiper(minScrollWrapper, {
            direction: 'vertical',
            slidesPerView: 5,
            spaceBetween: 5,
            mousewheel: true,
            loop: true,
            observer: true,
            observeParents: true,
        });
        SwiperMinutes.slideTo(parseInt(CurrentMinutes) + 3);

        let SwiperAMPM = new window.Swiper(ampmScroll,
        {
            direction: 'vertical',
            spaceBetween: 0,
            mousewheel: true,
            loop: false,
            observer: true,
            observeParents: true,
        });
        SwiperAMPM.slideTo(parseInt(CurrentAMPMIndex));

        SwiperHours.on('slideChange', function ()
        {
            window.ChangeCurrentTime(SwiperHours, SwiperMinutes, SwiperAMPM, CurrentTimeText, pingNowButton, WhichVerifyTimeContainer, WhichVerifyText, functiontocall);
        });

        SwiperMinutes.on('slideChange', function ()
        {
            window.ChangeCurrentTime(SwiperHours, SwiperMinutes, SwiperAMPM, CurrentTimeText, pingNowButton, WhichVerifyTimeContainer, WhichVerifyText, functiontocall);
        });
    
        SwiperAMPM.on('slideChange', function()
        {
            window.ChangeCurrentTime(SwiperHours, SwiperMinutes, SwiperAMPM, CurrentTimeText, pingNowButton, WhichVerifyTimeContainer, WhichVerifyText, functiontocall);
        });

        window.ChangeCurrentTime(SwiperHours, SwiperMinutes, SwiperAMPM, CurrentTimeText, pingNowButton, WhichVerifyTimeContainer, WhichVerifyText, functiontocall);
    }
}

window.ChangeCurrentTime = function(SwiperHours, SwiperMinutes, SwiperAMPM, CurrentTimeText, pingNowButton, WhichVerifyTimeContainer, WhichVerifyText, functiontocall)
{
    let HoursActiveSlide = SwiperHours.slides[SwiperHours.activeIndex + 2];
    let HourValue = HoursActiveSlide.getAttribute("hour-value");

    let MinutesActiveSlide = SwiperMinutes.slides[SwiperMinutes.activeIndex + 2];
    let MinutesValue = MinutesActiveSlide.getAttribute("min-value");

    let AMPMActiveSlide = SwiperAMPM.slides[SwiperAMPM.activeIndex];
    let AMPMValue = AMPMActiveSlide.getAttribute("ampm-value");

    let TextToDisplay = HourValue + ":" + MinutesValue.toString().padStart(2, "0") + " " + AMPMValue;

    CurrentTimeText.innerHTML = TextToDisplay;

    pingNowButton.onclick = function()
    {
        window.event.preventDefault();
        window.event.stopPropagation();

        WhichVerifyTimeContainer.setAttribute("hour-value", HourValue);
        WhichVerifyTimeContainer.setAttribute("min-value", MinutesValue);
        WhichVerifyTimeContainer.setAttribute("ampm-value", AMPMValue);

        if(WhichVerifyText.tagName  == "INPUT")
        {
            WhichVerifyText.value = TextToDisplay;
        }
        else
        {
            WhichVerifyText.innerHTML = TextToDisplay;
        }

        if(functiontocall != null) // Call Function After It ----------------------
        {
            if(typeof functiontocall === 'string')
            {
                eval(functiontocall);
            }
            else
            {
                functiontocall();
            }
        }
    }
}



// Prepare Calendar Cell ======================================================================


window.PreparePrevCurrentNextMonthCalendarInfo = function(year, month)
{
    const firstDay = new Date(year, month - 1, 1);
    const lastDay = new Date(year, month, 0);

    const firstWeekDay = firstDay.getDay(); // First Day Index (Sun = 0, Mon = 1, ...) of the Current Month
    const totalDays = lastDay.getDate(); // Total Day of the Current Month

    const cells = []; // Prepare an Array For Past, Current, Next Month Data -------------

    // Previous month ----------------------------------------------------------
    
    const prevMonthLastDay = new Date(year, month - 1, 0); // Last Day of the Previous Month
    const prevMonthDays = prevMonthLastDay.getDate(); // How Many Days Previous Month

    for(let i = firstWeekDay - 1; i >= 0; i--) // Get The Remaining Days for Previous Month Based On How Many Days (Last Month) - First Day Index (Current Month) 
    {
        const dayNumber = prevMonthDays - i;
        const date = new Date(year, month - 2, dayNumber);

        cells.push({
            date: window.formatDatetoString(date),
            day: dayNumber,
            datevalue: date,
            isOtherMonth: true // To Mark that This Data is Previous Month
        });
    }

    // Current month ----------------------------------------------------------

    for(let day = 1; day <= totalDays; day++)
    {
        const date = new Date(year, month - 1, day);

        cells.push({
            date: window.formatDatetoString(date),
            day,
            datevalue: date,
            isOtherMonth: false  // To Mark that This Data is Current Month
        });
    }

    // Fill last row ----------------------------------------------------------

    const remainder = cells.length % 7; // Get the Remainder Using %, which is the last cells of the last array from current date

    if(remainder > 0)
    {
        const needed = 7 - remainder; // How Many Needed to Fully Cover the Remaining Cells

        for(let day = 1; day <= needed; day++)
        {
            const date = new Date(year, month, day);

            cells.push({
                date: window.formatDatetoString(date),
                day,
                datevalue: date,
                isOtherMonth: true
            });
        }
    }

    return cells;
}


window.formatDatetoString = function(date)
{
    const year = date.getFullYear();

    const month = String(date.getMonth() + 1).padStart(2, "0");

    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
}
